import generalApi from "../../api/generalApi";

const state = {
  idleTimeout: 180,
  resultsTimeout: 180,
  dialogTimeout: 15,
  fontSize: 20,
  defaultAudioVolume: 0.5,
  largeFont: false,
  disableTimeoutWarning: false,
  siteVersion: "0.0.0.0",
  loginTimeout: 5,
  displayCorrectAnswer: false,
  displayTestReview: false,
  updateCheckInterval: 60,
  mediaUrl: "",
  settingsSet: false,
  showLogoutButton: false,
};

const getters = {
  idleTimeout(state) {
    return state.idleTimeout;
  },
  resultsTimeout(state) {
    return state.resultsTimeout;
  },
  dialogTimeout(state) {
    return state.dialogTimeout;
  },
  fontSize(state) {
    return state.fontSize;
  },
  largeFont(state) {
    return state.largeFont;
  },
  disableTimeoutWarning(state) {
    return state.disableTimeoutWarning;
  },
  defaultAudioVolume(state) {
    return state.defaultAudioVolume;
  },
  loginTimeout(state) {
    let storageLoginTimeout = null;
    try {
      storageLoginTimeout = parseInt(localStorage.getItem("logintimeout"));
    } catch (error) {
      console.log(error);
    }
    return storageLoginTimeout || state.loginTimeout;
  },
  displayCorrectAnswer(state) {
    return state.displayCorrectAnswer;
  },
  displayTestReview(state) {
    return state.displayTestReview;
  },
  updateCheckInterval(state) {
    return state.updateCheckInterval;
  },
  mediaUrl(state) {
    return state.mediaUrl;
  },
  settingsSet(state) {
    return state.settingsSet;
  },
  showLogoutButton(state) {
    return state.showLogoutButton;
  },
};

const mutations = {
  TOGGLE_FONT(state, isLarge) {
    state.largeFont = isLarge;
  },
  SET_IDLE_TIMEOUT(state, timeout) {
    state.idleTimeout = timeout;
  },
  SET_DISABLE_TIMEOUT_WARNING(state, value) {
    state.disableTimeoutWarning = value;
  },
  SET_SETTINGS(state, value) {
    state.idleTimeout = value.idleTimeout || 180;
    state.resultsTimeout = value.resultsIdleTimeout || 30;
    state.defaultAudioVolume = value.defaultAudioVolume || 0.5;
    state.displayCorrectAnswer = value.displayCorrectAnswer || false;
    state.displayTestReview = value.displayTestReview || false;
    state.mediaUrl = value.mediaUrl || "";
    state.updateCheckInterval = value.updateCheckInterval || 30;
    state.showLogoutButton = value.showLogoutButton || false;
  },
  SET_SETTINGS_SET(state, value) {
    state.settingsSet = value;
  },
  SET_AUDIO_VOLUME(state, value) {
    state.defaultAudioVolume = value;
  },
};

const actions = {
  toggleFontSize({ commit, getters }) {
    const largeFont = getters.largeFont;
    commit("TOGGLE_FONT", !largeFont);
  },
  setIdleTimeOut({ commit }, timeout) {
    commit("SET_IDLE_TIMEOUT", timeout);
  },
  setDisableTimeoutWarning({ commit }, value) {
    commit("SET_DISABLE_TIMEOUT_WARNING", value);
  },
  async getSettings({ commit, dispatch, getters }, value) {
    try {
      if (!getters.settingsSet || value) {
        if (!value) {
          dispatch("setBusy");
        }
        const settings = await generalApi.getSettings();
        commit("SET_SETTINGS", settings);
        commit("SET_SETTINGS_SET", true);
      } else {
        console.log("Already have settings");
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch("clearBusy");
    }
  },
  updateAudioVolume({ commit }, value) {
    commit("SET_AUDIO_VOLUME", value);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
